import { Injectable } from '@angular/core';

@Injectable()
export class SingleFilterBarService {
  // recordState saves the current usages tab selection
  private recordTabState = {};

  setRecordTabState(key: string, value: string | number) {
    this.recordTabState[key] = value;
  }

  getRecordTabState(key: string): string | number {
    return this.recordTabState[key];
  }
}
